import React from 'react';
import Meta from '../components/Meta';
import VirtualTemples from './VirtualTemples';

const RamMandir = () => {
  // Schema markup for structured data
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "LandmarksOrHistoricalBuildings",
    "name": "Ram Mandir Ayodhya",
    "alternateName": "Shri Ram Janmabhoomi Temple",
    "description": "The Ram Mandir is a Hindu temple dedicated to Lord Rama, located in Ayodhya, Uttar Pradesh, India. It is one of the most significant religious and cultural landmarks in India, representing the birthplace of Lord Rama as per Hindu scriptures.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Ram Janmabhoomi",
      "addressLocality": "Ayodhya",
      "addressRegion": "Uttar Pradesh",
      "addressCountry": "India"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "26.795400",
      "longitude": "82.194600"
    },
    "url": "https://vedamerchandise.com/ram-mandir",
    "image": "https://vedamerchandise.com/images/avatars/ayodhya_ram_mandir.glb"
  };

  return (
    <>
      <Meta 
        title="Ram Mandir Ayodhya - 3D Virtual Tour | VEDA Virtual Temples"
        description="Experience the divine architecture of Ram Mandir in Ayodhya through our immersive 3D virtual tour. Explore the spiritual significance and intricate design of this sacred Hindu temple."
        keywords="ram mandir, ayodhya temple, lord rama temple, 3d virtual tour, ram janmabhoomi, hindu temple, virtual pilgrimage"
        author="VEDA Merchandise"
        ogTitle="Ram Mandir Ayodhya - 3D Virtual Tour"
        ogDescription="Experience the divine architecture of Ram Mandir in Ayodhya through our immersive 3D virtual tour. Explore the spiritual significance and intricate design of this sacred Hindu temple."
        ogImage="https://vedamerchandise.com/images/avatars/ayodhya_ram_mandir.glb"
        ogUrl="https://vedamerchandise.com/ram-mandir"
        ogType="website"
        twitterCard="summary_large_image"
        twitterTitle="Ram Mandir Ayodhya - 3D Virtual Tour"
        twitterDescription="Experience the divine architecture of Ram Mandir in Ayodhya through our immersive 3D virtual tour."
        twitterImage="https://vedamerchandise.com/images/avatars/ayodhya_ram_mandir.glb"
        robots="index, follow"
        canonicalUrl="https://vedamerchandise.com/ram-mandir"
        schemaMarkup={schemaMarkup}
      />
      <VirtualTemples defaultTempleId={1} />
    </>
  );
};

export default RamMandir;